// Portfolio data strictly conforming to verified facts
// Note: Metrics are excluded per specification until verified by candidate.

export const personalInfo = {
  name: "Prasanna Kumar",
  headline: "Backend Engineer (Golang / Python) | Distributed Systems, Event-Driven Pipelines, Observability",
  location: "Bengaluru, India",
  summary:
    "Backend engineer with about 3 years of experience building Golang and Python microservices, real-time event pipelines and observability tooling for an AIOps and IT operations automation platform. Worked with Cassandra/ScyllaDB, NATS and Prometheus in production, and integrated LLM-based incident analysis into operations workflows.",
  links: {
    linkedin: "https://linkedin.com/in/prasannakumarhm",
    github: "https://github.com/prasanna34567u78",
    email: "prasannakumarhm078@gmail.com",
    resume: "/resume.pdf",
  },
};

export const experiences = [
  {
    role: "Senior Software Engineer",
    company: "Algomox Pvt Ltd",
    location: "Bengaluru",
    period: "Jan 2024 - Present",
    domain: "AIOps, IT operations automation, cybersecurity",
    highlights: [
      "Designed and delivered 10+ independently deployable microservices in Golang (Gin) and Python (Flask/Django) with Cassandra/ScyllaDB (GoCQL) and REST APIs.",
      // TODO: add verified metric (e.g. sustained events/sec, alert latency)
      "Built NATS-based event ingestion and processing pipelines for real-time alerting.",
      // TODO: add verified metric (e.g. infrastructure observability coverage % increase)
      "Wrote Prometheus exporters for Node, SQL, NoSQL and SNMP targets.",
      // TODO: add verified metric (e.g. % reduction in ticket handling time, % resolution accuracy improvement)
      "Built an LLM-assisted incident analysis workflow with LangChain and a RAG pipeline over ITSM documentation.",
      "Led migration of platform UI to an Angular micro-frontend architecture with Module Federation.",
      "Integrated Google SecOps APIs; built GitHub Actions CI/CD pipelines deploying to Kubernetes; mentored 4 junior engineers.",
    ],
  },
  {
    role: "Full Stack Developer Intern",
    company: "Oasis Infobyte",
    location: "Dharwad, India",
    period: "Aug 2023 - Sep 2023",
    domain: "E-Commerce",
    highlights: [
      "Built a MERN e-commerce application with JWT authentication and role-based access control.",
    ],
  },
  {
    role: "Software Developer Intern",
    company: "DocYardHQ",
    location: "Dharwad, India",
    period: "Jan 2023 - Jul 2023",
    domain: "Enterprise Infrastructure & Security",
    highlights: [
      // TODO: add verified metric (e.g. user accounts supported)
      "Implemented JWT/OAuth 2.0 authentication with session-scoped access control.",
      // TODO: add verified metric (e.g. number of services monitored, stakeholder alert latency)
      "Built a WebSocket-based service monitoring system.",
    ],
  },
];

export const projects = [
  {
    title: "High-Availability Voting Platform",
    technologies: ["Go", "Gin", "Cassandra", "Docker", "JWT"],
    description:
      "Distributed voting backend featuring JWT-secured REST APIs and password hashing. Engineered for high availability on Cassandra and containerized with Docker.",
    // TODO: add verified metric (e.g. concurrent votes capacity, latency target)
    githubPlaceholder: "https://github.com/prasanna34567u78/voting-platform",
    category: "Distributed Systems & Go",
  },
  {
    title: "Algorithmic Trading and Monitoring Platform",
    technologies: ["Python", "FastAPI", "MetaTrader 5 API"],
    description:
      "Python application that ingests real-time market data, evaluates trading signals, and executes configured strategies through MetaTrader 5 API with a FastAPI dashboard.",
    githubPlaceholder: "https://github.com/prasanna34567u78/algorithmic-trading",
    category: "Financial Tech & Automation",
  },
  {
    title: "AIOps Incident Analysis Workflow",
    technologies: ["Python", "LangChain", "RAG"],
    description:
      "LLM-assisted incident analysis workflow combining LangChain and a RAG pipeline over enterprise ITSM documentation to automate incident triage and root cause discovery.",
    // TODO: add verified metric (e.g. % reduction in first-response time)
    githubPlaceholder: "https://github.com/prasanna34567u78/aiops-incident-analysis",
    category: "AI & Operations",
  },
];

export const skillGroups = [
  {
    category: "Languages",
    skills: ["Go", "Python", "SQL", "TypeScript", "JavaScript"],
  },
  {
    category: "Backend",
    skills: [
      "Gin",
      "Flask",
      "Django",
      "FastAPI",
      "REST",
      "Microservices",
      "Event-Driven Architecture",
    ],
  },
  {
    category: "Data and Messaging",
    skills: [
      "Cassandra",
      "ScyllaDB",
      "PostgreSQL",
      "MySQL",
      "Redis",
      "NATS",
      "Kafka",
    ],
  },
  {
    category: "Observability",
    skills: ["Prometheus", "SNMP"],
  },
  {
    category: "DevOps",
    skills: ["Docker", "Kubernetes", "GitHub Actions", "Linux"],
  },
  {
    category: "Frontend",
    skills: ["Angular", "React"],
  },
  {
    category: "AI",
    skills: ["LLMs", "LangChain", "RAG"],
  },
];

export const education = {
  degree: "B.E. Computer Science",
  institution: "SDM College of Engineering and Technology, Dharwad (VTU)",
  period: "2020 - 2024",
  cgpa: "8.65 / 10",
};

export const achievements = [
  {
    title: "All India Rank 2",
    context: "Algostrike (IIT Dharwad contest)",
    detail: "National competitive programming competition",
  },
  {
    title: "250+ LeetCode Problems",
    context: "Data Structures & Algorithms",
    detail: "Focused on graph theory, trees, dynamic programming, and systems algorithms",
  },
  {
    title: "5-Star HackerRank",
    context: "Problem Solving & Core Languages",
    detail: "Top-tier rating demonstrating core algorithm speed and precision",
  },
];
